import {CarteraInterface} from "../models/cartera.interface";
import { PaginationStateInterface } from "../models/pagination-state.interface";

export namespace CarteraAction {

  export class FetchTags {

    static readonly type = '[CarteraAction] Fetch tags';
    constructor() {}
  }

  export class FetchTipoOperacion {

    static readonly type = '[CarteraAction] Fetch tipo operacion';
    constructor() {}
  }

  export class FetchFuentes {

    static readonly type = '[CarteraAction] Fetch fuentes';
    constructor() {}
  }

  export class FetchBrokers {

    static readonly type = '[CarteraAction] Fetch brokers';
    constructor() {}
  }

  export class FetchTipoVencimiento {

    static readonly type = '[CarteraAction] Fetch tipo vencimiento';
    constructor() {}
  }

  export class FetchColumnas {

    static readonly type = '[CarteraAction] Fetch columnas';
    constructor(public tipo: string) {}
  }

  export class FetchCarteras {

    static readonly type = '[CarteraAction] Fetch carteras';
    constructor(public hideLoading = false, public id = null) {}
  }

  export class FetchOperacionesSimbolo {

    static readonly type = '[CarteraAction] Fetch operaciones simboo';
    constructor(public id: number, public hideLoading = false) {}
  }

  export class FetchPaginationCartera {

    static readonly type = '[CarteraAction] Fetch pagination';
    constructor(public pagination: any) {}
  }

  export class UpsertCartera {

    static readonly type = '[CarteraAction] Add cartera';
    constructor(public cartera: CarteraInterface) {}
  }

  export class CloneCartera {

    static readonly type = '[CarteraAction] Clone cartera';
    constructor(public id: number) {}
  }

  export class RemoveCartera {

    static readonly type = '[CarteraAction] Remove cartera';
    constructor(public id: number) {}
  }

}
